// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.feedtomanual.RentalManagerUserPropertyFeedToManualWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyFeedToManualWebApiHandler_convert,
  RentalManagerUserPropertyFeedToManualWebApiHandler_convertAll,
  RentalManagerUserPropertyFeedToManualWebApiHandler_statuses,
  RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  ListingAlias,
  UserPropertyFeedToManualConvertAllResponseWebDto,
  UserPropertyFeedToManualConvertResponseWebDto,
  UserPropertyFeedToManualStatusesResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface ConvertParams {
  bypassManualDupeRestriction?: boolean;
  keepExistingListingIdentifiers?: boolean;
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyFeedToManualWebApiHandler_convert_Args {
  getParams: ConvertParams;
}

export type RentalManagerUserPropertyFeedToManualWebApiHandler_convert_Options = UseMutationOptions<
  UserPropertyFeedToManualConvertResponseWebDto,
  unknown,
  RentalManagerUserPropertyFeedToManualWebApiHandler_convert_Args
>;

/**
 * Convert a feed listing to manual listing
 */
export const useRentalManagerUserPropertyFeedToManualWebApiHandler_convert = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFeedToManualWebApiHandler_convert_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFeedToManualWebApiHandler_convert_Args) =>
      RentalManagerUserPropertyFeedToManualWebApiHandler_convert(args.getParams, httpClient),
  });
};

export type RentalManagerUserPropertyFeedToManualWebApiHandler_convertAll_Options = UseMutationOptions<
  UserPropertyFeedToManualConvertAllResponseWebDto,
  unknown,
  void
>;

/**
 * Convert all convertible feed listings to manual listings
 */
export const useRentalManagerUserPropertyFeedToManualWebApiHandler_convertAll = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFeedToManualWebApiHandler_convertAll_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => RentalManagerUserPropertyFeedToManualWebApiHandler_convertAll(httpClient),
  });
};

export type RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_Options = UseQueryOptions<
  UserPropertyFeedToManualStatusesResponseWebDto,
  unknown,
  UserPropertyFeedToManualStatusesResponseWebDto,
  readonly [string]
>;

const RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_GetKey = () =>
  [RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_Path] as const;

export const RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_GetKey(),
    queryFn: () => RentalManagerUserPropertyFeedToManualWebApiHandler_statuses(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Statuses of feed listing to manual listing conversions
 */
export const useRentalManagerUserPropertyFeedToManualWebApiHandler_statuses = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyFeedToManualWebApiHandler_statuses.getKey =
  RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_GetKey;
